import { useEffect, useMemo } from 'react';
import { useSelector, AppState } from '../store/Store';
import { composeTheme } from './composeTheme';

export { composeTheme };

// Memoized on the four values the theme actually depends on. Building it is a deep lodash
// merge of the whole palette plus a full component-override pass, and it used to run on
// every render of _app — so any state change up there (a scroll listener, say) handed
// ThemeProvider a brand-new theme identity and re-styled every component on the page at
// once. On a long page that full restyle reads as the page reloading under you.
export const BuildTheme = (config: any = {}) => {
  const customizer = useSelector((state: AppState) => state.customizer);
  const { theme: themeName, direction } = config;
  const { activeMode, borderRadius } = customizer;

  return useMemo(
    () => composeTheme(themeName, direction, activeMode, borderRadius),
    [themeName, direction, activeMode, borderRadius],
  );
};

const ThemeSettings = () => {
  const activDir = useSelector((state: AppState) => state.customizer.activeDir);
  const activeTheme = useSelector((state: AppState) => state.customizer.activeTheme);
  const theme = BuildTheme({
    direction: activDir,
    theme: activeTheme,
  });
  useEffect(() => {
    document.dir = activDir;
  }, [activDir]);

  return theme;
};

export { ThemeSettings };
